<template lang="pug">
div(
    :style="{ opacity: loading ? opacity : 1, transform: loading ? `sclae(${scale})` : `scale(1)` }"
    class="tl-loading-opaq"
)
    slot
</template>

<script setup>
import { computed, inject } from 'vue'
import { getInjects } from '@/components/$tl/utils/injects'

const props = defineProps({
    loading: Boolean,
    opacity: [String, Number],
    scale: [String, Number],
})

const injects = getInjects(props, inject)

const loading = computed(() => props.loading ?? injects.loading?.value)
const opacity = computed(() => props.opacity ?? injects.opacity?.value ?? 0.7)
const scale = computed(() => props.scale ?? injects.scale?.value ?? 0.95)
</script>

<style lang="sass" scoped>
.tl-loading-opaq
    transition: var(--transition-default)
</style>
